import {Component, ElementRef, OnInit} from '@angular/core';

@Component({
  selector: '[sb-comp-medium-upload]',
  templateUrl: './medium-upload.component.html',
  styleUrls: ['./medium-upload.component.scss'],
  standalone: false,
})
export class MediumUploadComponent implements OnInit {
  htmlElement: HTMLElement;
  isDragOver: boolean;

  constructor(private el: ElementRef) {
    this.htmlElement = el.nativeElement.nodeName;
  }

  ngOnInit(): void {}
}
